import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ShieldCheckIcon } from 'lucide-react';
export function PersonalSupportWorkers() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-948">
      <Navbar data-id="element-949" />
      <main className="flex-1" data-id="element-950">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-951">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-952">
            <div className="inline-flex items-center gap-2 bg-soft-teal text-accent-teal-dark text-xs font-semibold px-3 py-1.5 rounded-full mb-4" data-id="element-953">
              <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-954" />
              Services
            </div>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-955">
              Personal Support Workers (PSW)
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-956">
              Compassionate daily living assistance, personal care, and
              companionship.
            </p>
          </div>
        </section>
        <div className="max-w-3xl mx-auto px-4 py-16 text-text-muted leading-relaxed space-y-6" data-id="element-957">
          <p data-id="element-958">
            Our Personal Support Workers (PSWs) provide essential daily living
            assistance, personal care, and companionship to individuals in
            various healthcare settings, including long-term care facilities,
            hospitals, and private homes.
          </p>
          <p data-id="element-959">
            Every PSW on our platform is thoroughly vetted, background-checked,
            and insured. They are trained to assist with bathing, grooming,
            mobility, meal preparation, and social engagement, ensuring patients
            receive compassionate and dignified care.
          </p>
        </div>
      </main>
      <StickyFooter data-id="element-960" />
    </div>;
}